
<form [formGroup]="comboForm">
  <kendo-floatinglabel text="{{label}}">
    <kendo-dropdownlist #combo
                        formControlName="comboValue"
                        [data]="data"
                        [disabled]="disabled"
                        [filterable]="true"
                        (filterChange)="handleFilter($event)"
                        [textField]="'Fullname'"
                        [valueField]="'UUID'"
                        required
                        (selectionChange)="selectionChange($event)">
    </kendo-dropdownlist>
  </kendo-floatinglabel>
</form>
